import script from "./AppDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./AppDrawer.vue?vue&type=style&index=0&id=a4821e58&lang=scss"

const __exports__ = script;

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QList from 'quasar/src/components/item/QList.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer,QToolbar,QExpansionItem,QItemSection,QAvatar,QCard,QItem,QIcon,QScrollArea,QList,QTooltip});qInstall(script, 'directives', {Ripple});
